import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import OrderItem from 'src/models/order-item/OrderItem'
import TipPoolTip from 'src/models/tip/TipPoolTip'
import TipShareRule from 'src/models/tip/TipShareRule'

export default class TipShare extends Model {
  static name = 'TipShare'

  static level = MODEL_LEVEL.SITE

  static paginate = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Tipping]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      orderItem: {
        type: OrderItem,
        default: null,
        output: true
      },
      tipShareRule: {
        type: TipShareRule,
        default: null,
        output: true
      },
      tipPoolTips: {
        type: [TipPoolTip],
        default: () => ([]),
        output: true
      },
      tipOutAmount: {
        type: Number,
        encode: encoders.money,
        default: 0,
        output: true
      },
      tipIncomeAmount: {
        type: Number,
        encode: encoders.money,
        default: 0,
        output: true
      },
      paymentType: {
        type: String,
        default: null,
        output: true
      }
    }
  }
}
